import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'

const secretKey = process.env.VITE_CRYPTO || ''

/**
 * Encripta um objeto usando AES.
 * @param data O objeto a ser encriptado.
 * @returns A string encriptada.
 */
export function encryptData(data: object): string {
  return AES.encrypt(JSON.stringify(data), secretKey).toString()
}

/**
 * Des encripta uma string encriptada usando AES.
 * @param encryptedData A string encriptada.
 * @returns O objeto des encriptado.
 */
export function decryptData(encryptedData: string): any {
  const bytes = AES.decrypt(encryptedData, secretKey)
  try {
    return JSON.parse(bytes.toString(Utf8))
  } catch {
    return null
  }
}
